import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/idle_fee_settlement_rules',
  component: Management,
  redirect: '/idle_fee_settlement_rules/detail',
  children: [
    // 编辑
    {
      path: 'edit',
      component: () => import('@/views/idle_fee_settlement_rules/Edit'),
      meta: {
        auth: Auth.updateIdleFeeSettlementRule
      }
    },
    // 详情
    {
      path: 'detail',
      component: () => import('@/views/idle_fee_settlement_rules/DetailLayout'),
      redirect: 'detail/rule_info',
      meta: {
        auth: Auth.showIdleFeeSettlementRule
      },
      children: [
        // 基本信息
        {
          path: 'rule_info',
          component: () => import('@/views/idle_fee_settlement_rules/details/Detail'),
          meta: {
            tabName: 'rule_info', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showIdleFeeSettlementRule
          }
        },
        // 站结算记录
        {
          path: 'ev_charging_station_settlements',
          component: () => import('@/views/idle_fee_settlement_rules/details/EvChargingStationSettlements'),
          meta: {
            tabName: 'ev_charging_station_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listEvChargingStationSettlements
          }
        },
        // 占位费账单结算记录
        {
          path: 'idle_fee_bill_settlements',
          component: () => import('@/views/idle_fee_settlement_rules/details/IdleFeeBillSettlements'),
          meta: {
            tabName: 'idle_fee_bill_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listIdleFeeBillSettlements
          }
        }
      ]
    }
  ]
}
